import PettyCashPage from './pettyCashPage';

export default PettyCashPage;
